<template>
  <main class="content">
    <SectionHero />
    <SectionAbout />
    <SectionDesc />
    <SectionAdvantage />
    <SectionMaterials />
    <SectionCalculator />
  </main>
</template>

<script>
import SectionHero from '@/components/MainPage/SectionHero.vue'
import SectionAbout from '@/components/MainPage/SectionAbout.vue'
import SectionDesc from '@/components/MainPage/SectionDesc.vue'
import SectionAdvantage from '@/components/MainPage/SectionAdvantage.vue'
import SectionMaterials from '@/components/MainPage/SectionMaterials.vue'
import SectionCalculator from '@/components/MainPage/SectionCalculator.vue'

export default {
  components: {
    SectionHero,
    SectionAbout,
    SectionDesc,
    SectionAdvantage,
    SectionMaterials,
    SectionCalculator
  },
  mounted () {
    if (this.$route.hash) {
      const elem = document.querySelector(this.$route.hash)
      elem.scrollIntoView({ block: 'start', behavior: 'smooth' })
    }
  }
}
</script>
